import { useAuthToken } from '@convex-dev/auth/react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Toaster } from 'sonner';
import { GlobalAIChatProvider } from '@/providers/GlobalAIChatProvider';
import { GlobalChatPanelMemo } from '@/components/chat/GlobalChatPanel';
import { ChatToggleButtonMemo } from '@/components/chat/ChatToggleButton';
import { AppRoutes } from '@/components/routing/AppRoutes';

/** Hide the global chat toggle button on the scene editor route (it has its own). */
function GlobalChatOverlay() {
  const { pathname } = useLocation();
  const isSceneEditor = pathname.startsWith('/reel/');

  return (
    <>
      <GlobalChatPanelMemo />
      {!isSceneEditor && <ChatToggleButtonMemo />}
    </>
  );
}

function App() {
  const token = useAuthToken();
  const isAuthenticated = token !== null;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="text-lg text-foreground-muted">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <GlobalAIChatProvider>
          <AppRoutes isAuthenticated={isAuthenticated} />
          {/* Global AI Chat - only visible when authenticated */}
          {isAuthenticated && <GlobalChatOverlay />}
        </GlobalAIChatProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
